import moment from 'moment'

import modalComponent from '@/modules/modal'

let birthdayChecked = false

/**
 * Clears the status of check if birthday warning has already been shown
 */
export function clearBirthdayChecked () {
  birthdayChecked = false
}

/**
 * Validator for children birthdays that checks if the given birthdates are properly selected
 */
export default class ChildrenBirthdayValidator {
  /**
   * @argument {HTMLFormElement} form
   */
  constructor (form, defaultDate = moment().subtract(3, 'years')) {
    this.form = form
    this.defaultDate = defaultDate
    this.inputs = form.querySelectorAll('.custom-select-people input[type="text"]').toArray()
    this.adultCountInput = this.inputs[0]
    this.childrenCountInput = this.inputs[1]
    this.childrenBirthdaysInputs = this.inputs.skip(2)
  }

  get childrenCount () {
    return this.childrenCountInput.value
  }

  get childrenBirthdays () {
    return this.childrenBirthdaysInputs
      .take(this.childrenCount)
      .map(input => moment(input.value, 'DD.MM.YYYY'))
  }

  /**
   * @return Returns true if at least one value is default (3 years back)
   */
  isAtLeastOneDateDefault () {
    return this.childrenBirthdays.some(birthday => birthday.isSame(this.defaultDate, 'day'))
  }

  /**
   * @return Returns true if the validation suceeded, false otherwise
   */
  validate () {
    if (this.isAtLeastOneDateDefault() && !birthdayChecked) {
      this.initValidationModal()
      return false
    }

    return true
  }

  initValidationModal () {
    const config = { 
      modalHeadline: 'Data urodzenia dzieci',
      modalContent: 'Nie zmieniłeś predefiniowanej daty urodzenia niepełnoletnich uczestników wycieczki, sprawdź czy wybrane daty  urodzenia są prawidłowe!',
      modalSize: 'small',
      modalTextAlign: 'center',
    }

    modalComponent.init(config)
    birthdayChecked = true
  }
}



// WEBPACK FOOTER //
// ./src/modules/search/ChildrenBirthdayValidator.js